import {
  CourtInsightType,
  DailyInsightType,
  InsightsRequestType,
  ModalityInsightType,
} from "../types/generalTypes";
import api from "./api";

export const getCourtInsights = async (
  request: InsightsRequestType
): Promise<DailyInsightType[]> => {
  try {
    const { data } = await api.post("/Insights/courts", request);

    const response: DailyInsightType[] = data.map((day: any) => ({
      date: day.date,
      totalReservations: day.totalReservations,
      courts: day.courts.map((court: any) => ({
        courtId: court.courtId,
        courtName: court.courtName,
        reservationCount: court.reservationCount,
      })),
    }));

    return response;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getModalityInsights = async (
  request: InsightsRequestType
): Promise<ModalityInsightType[]> => {
  try {
    const { data } = await api.post("/Insights/modalities", request);

    const response: ModalityInsightType[] = data.map((item: any) => ({
      modality: item.modality,
      reservationCount: item.reservationCount,
      percentage: item.percentage,
    }));

    return response;
  } catch (error) {
    console.error(error);
    return [];
  }
};
